export default {"src":"/_next/static/media/logoHeader.81ea8ccc.svg","height":33,"width":217};